import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { PlpPageNameModule } from '../plp-page-name/plp-page-name.module';
import { PlpNoContentComponent } from './plp-no-content.component';

@NgModule({
  declarations: [PlpNoContentComponent],
  imports: [CommonModule, I18nModule, RouterModule, PlpPageNameModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        PLPNoContent: {
          component: PlpNoContentComponent,
        },
      },
    }),
  ],
  exports: [PlpNoContentComponent],
})
export class PlpNoContentModule {}
